'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _vstui = require('@vitalsource/vstui');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Star = function (_PureComponent) {
  function Star() {
    return _classCallCheck(this, Star), _possibleConstructorReturn(this, (Star.__proto__ || Object.getPrototypeOf(Star)).apply(this, arguments));
  }

  return _inherits(Star, _PureComponent), _createClass(Star, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_vstui.Icon, _extends({}, this.props, {
        height: 16,
        width: 16
      }), _react2.default.createElement('path', {
        d: 'M8 0a.9.9 0 0 0-.852.58L5.67 4.32a.915.915 0 0 1-.794.577l-4.017.25C.031 5.2-.307 6.238.334 6.768L3.436 9.33c.274.226.392.59.303.934L2.736 14.16c-.16.622.332 1.147.887 1.147a.907.907 0 0 0 .49-.146l3.396-2.159a.916.916 0 0 1 .982 0l3.396 2.16a.906.906 0 0 0 .49.145c.555 0 1.047-.525.887-1.147l-1.003-3.896a.915.915 0 0 1 .302-.934l3.103-2.563c.64-.529.303-1.568-.525-1.619l-4.017-.25a.915.915 0 0 1-.794-.577L8.851.58A.9.9 0 0 0 8.001 0m0 3.946l.441 1.12a2.957 2.957 0 0 0 2.556 1.858l1.202.074-.929.768a2.955 2.955 0 0 0-.975 3.004l.3 1.166-1.017-.646a2.934 2.934 0 0 0-3.158 0l-1.017.646.3-1.166a2.955 2.955 0 0 0-.975-3.004L3.8 6.998l1.202-.074a2.957 2.957 0 0 0 2.556-1.858L8 3.946'
      }));
    }
  }]), Star;
}(_react.PureComponent);

Star.displayName = 'Star', Star.vstuiName = 'Icon', exports.default = Star;